<template>
    <div class="page">
        <el-button type="primary" :icon="ArrowLeft" plain @click="goBack">返回</el-button>
        <el-tabs class="elTabs" v-model="tab_active" @tab-change="tabChange">
            <el-tab-pane label="推送服务信息" name="1"></el-tab-pane>
            <el-tab-pane label="设备推送信息" name="2"></el-tab-pane>
        </el-tabs>
        <el-form ref="search_form" :inline="true" :model="search_params" label-position="top" class="search-form">
            <el-form-item label="日期">
                <el-date-picker
                    v-model="search_params.date_range"
                    style="width: 250px"
                    type="datetimerange"
                    value-format="YYYY-MM-DD HH:mm:ss"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                />
            </el-form-item>
            <el-form-item label="IMEI" prop="IMEI" v-if="tab_active === '2'">
                <el-input style="width: 165px" placeholder="请输入IMEI" v-model="search_params.IMEI" clearable />
            </el-form-item>
            <el-form-item>
                <el-button type="primary" :icon="Search" @click="getTableData">搜索</el-button>
                <el-button :icon="Refresh" @click="resetQueryForm">重置</el-button>
            </el-form-item>
        </el-form>
        <el-table
            :data="table_data"
            border
            style="width: 100%"
            v-loading="tableLoading"
            height="calc(100vh - 300px)"
            v-if="tab_active === '1'"
        >
            <el-table-column label="推送时间" min-width="100" prop="datetime"></el-table-column>
            <el-table-column label="推送账户" min-width="100" prop="account"></el-table-column>
            <el-table-column label="推送设备数/推送成功数/推送失败数" min-width="100" prop="device_count">
                <template #default="{ row }">
                    {{ row.device_count }} / {{ row.success_count }} /
                    {{ row.failed_count }}
                </template>
            </el-table-column>
            <el-table-column label="操作" fixed="right" width="220">
                <template #default="{ row }">
                    <el-button
                        type="primary"
                        :icon="View"
                        link
                        size="small"
                        @click="viewDetail(row)"
                        v-permission="['heating:temp-calibration:set-normal-temp']"
                    >
                        详情
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-table
            :data="table_data"
            border
            style="width: 100%"
            v-loading="tableLoading"
            height="calc(100vh - 300px)"
            v-else-if="tab_active === '2'"
        >
            <el-table-column label="户名" min-width="100" prop="name"></el-table-column>
            <el-table-column label="IMEI" min-width="100" prop="IMEI"></el-table-column>
            <el-table-column label="状态" min-width="100" prop="status"></el-table-column>
            <el-table-column label="地址" min-width="100" prop="url"></el-table-column>
            <el-table-column label="推送结果" min-width="100" prop="account"></el-table-column>
        </el-table>
        <Pagination
            :current-page="page_params.page"
            :page-size="page_params.page_size"
            :total="total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
        ></Pagination>
        <log-detail v-if="formDialogVisible" v-model="formDialogVisible" :modelId="selectModelId" @updateForm="getTableData" />
    </div>
</template>

<script setup>
import { defineEmits, onMounted, reactive, ref } from 'vue'
import { ArrowLeft, Refresh, Search, View } from '@element-plus/icons'
import Pagination from '@/components/Pagination/index.vue'
import LogDetail from './components/LogDetail.vue'

const emits = defineEmits(['update:modelValue'])

// 关闭弹窗
function goBack() {
    emits('update:modelValue', false)
    table_data.value = []
}

// 标签页
const tab_active = ref('1')
function tabChange(tab) {
    tab_active.value = tab
    getTableData()
}

// 重置
const search_form = ref(null)
const resetQueryForm = () => {
    search_form.value.resetFields()
    getTableData()
}
// 数据源
const search_params = reactive({
    date_range: [],
    IMEI: ''
})

const table_data = ref([])
const tableLoading = ref(true)
const total = ref(0)

// 获取列表数据
async function getTableData() {
    // tableLoading.value = true
    const params = { ...search_params, ...page_params }
    /*getDeviceList(params).then((data) => {
        table_data.value = data.lists
    })*/
    table_data.value = [
        {
            device_type: 1,
            push_type: 1
        }
    ]
    // total.value = data.total
    tableLoading.value = false
}

// 分页相关
const page_params = reactive({
    page: 1,
    page_size: 10
})
const handleSizeChange = (currentSize) => {
    page_params.page_size = currentSize
    page_params.page = 1
    getTableData()
}
const handleCurrentChange = (currentPage) => {
    page_params.page = currentPage
    getTableData()
}

// 表单弹窗
const formDialogVisible = ref(false)
const isForm = ref(false) // 是否是表单
const selectModelId = ref('') // 点中的模块id
const detail_data = ref({})

// 查看详情
function viewDetail(row) {
    isForm.value = false
    selectModelId.value = row.id
    detail_data.value = row
    formDialogVisible.value = true
}

onMounted(() => {
    getTableData()
})
</script>

<style lang="scss" scoped>
.elPageHeader:deep(.el-page-header__title) {
    white-space: nowrap;
}
.page {
    width: 100%;
    padding: 0 20px;
    background-color: #ffffff;
}

.page-container {
    width: 100%;
    height: 100%;
    display: flex;
}

.area-container {
    width: 260px;
    flex-shrink: 0;
    border-right: 1px solid #ccdaee;
    padding: 0 15px 15px 15px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    box-sizing: border-box;
}

.area-container .area-search {
    display: flex;
    align-items: center;
    padding: 10px 0;
}

.area-container .area-tree {
    flex: 1;
    overflow-y: auto;
}

.data-container {
    flex: 1;
    width: calc(100% - 260px);
    padding: 20px;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
}

.temp {
    display: flex;
    align-items: center;
    vertical-align: middle;
}

.temp.up {
    color: #f56c6c;
}

.temp.down {
    color: #67c23a;
}
</style>
